import React from 'react';
import styles from './styles.module.scss';
import {CheckBox, Flex, Text} from '@priority-software/priority-style-react';
import {getTopDialogZindex} from '../../../../_shared/GWTBridge/invoke/priModalDlg';
import {isRTL} from '../../../../Localization';
import {Tooltip} from '../../../../components/Common/Tooltip/index';

type Props = {
    formTitle: string;
    disabled: boolean;
    checked: boolean;
    tooltipText?: string;
};

export const ListItem = ({formTitle, disabled, checked, tooltipText}: Props) => {
    const listItem = (
        <CheckBox disabled={disabled} checked={checked} componentClasses={styles.checkboxInput}>
            <Text skin="paragraph-2" textColor="primary-700">
                {formTitle}
            </Text>
        </CheckBox>
    );
    return (
        <Flex justifyContent="flex-start" componentClasses={styles.inputContainer}>
            {!disabled && listItem}
            {disabled && (
                <Tooltip
                    delay={100}
                    tooltip={tooltipText}
                    zIndex={getTopDialogZindex()}
                    position={isRTL() ? 'right center' : 'left center'}
                >
                    {listItem}
                </Tooltip>
            )}
        </Flex>
    );
};
